module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_vm._t("body", [_c('p', [_vm._v("Dziękujemy za założenie konta demo. Cieszymy się, że wypróbujesz nasze rozwiązanie!")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', [_vm._v("📞 Masz pytania? Skontaktuj się z nami – chętnie pomożemy!")]), _vm._v(" "), _c('p', [_vm._v("🎥 Zobacz, jak to działa! Obejrzyj nasz film instruktażowy, aby poznać możliwości platformy.")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', [_vm._v("Życzymy owocnych testów!")]), _vm._v(" "), _c('iframe', {
    attrs: {
      "width": "700px",
      "height": "500px",
      "src": "https://www.youtube.com/embed/p2XFz7szqzA?si=cRqPWZ-sWb0GByed&enablejsapi=1",
      "title": "YouTube video player",
      "frameborder": "0",
      "allow": "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share",
      "referrerpolicy": "strict-origin-when-cross-origin",
      "allowfullscreen": ""
    }
  })])], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-40a135e3!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modal/type/FirstLoginModal.vue
// module id = 1276
// module chunks = 2